module.exports = __webpack_public_path__ + "static/media/carriere_banniere_inv.4307d949.jpg";